"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NavigationSection = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _List = _interopRequireDefault(require("../../../List"));

var _ListSubheader = _interopRequireDefault(require("../../../ListSubheader"));

var _shapes = require("../../shapes");

var _styles2 = require("./styles");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var NavigationSection = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(NavigationSection, _Component);

  var _super = _createSuper(NavigationSection);

  function NavigationSection() {
    var _this;

    (0, _classCallCheck2.default)(this, NavigationSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isSelected", function (item, itemKey) {
      var pathName = window.location.pathname.toLowerCase();

      if (item.href === "/") {
        if (pathName === "/") {
          return true;
        } else {
          return false;
        }
      }

      var _this$props = _this.props,
          openSubNav = _this$props.openSubNav,
          openSection = _this$props.openSection,
          sectionKey = _this$props.sectionKey;
      var selectWithHref = item.excludedPaths && item.excludedPaths.length > 0 ? pathName.startsWith(item.href.toLowerCase()) && !item.excludedPaths.includes(pathName) : item.href && pathName.includes(item.href.toLowerCase());
      return itemKey === openSubNav && sectionKey === openSection || openSubNav === "" && selectWithHref;
    });
    return _this;
  }

  (0, _createClass2.default)(NavigationSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          id = _this$props2.id,
          section = _this$props2.section,
          sectionKey = _this$props2.sectionKey,
          toggleSubMenu = _this$props2.toggleSubMenu,
          classes = _this$props2.classes,
          isSelected = _this$props2.isSelected,
          openSubNav = _this$props2.openSubNav,
          openSection = _this$props2.openSection;

      if (section.hide) {
        return null;
      }

      return /*#__PURE__*/_react.default.createElement(_List.default, {
        id: "".concat(id),
        sideNav: true,
        className: (0, _classnames.default)(classes.wrapper),
        "aria-label": section.title,
        listSubheader: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, section.title ? /*#__PURE__*/_react.default.createElement(_ListSubheader.default, {
          isSideNav: "header",
          id: "".concat(id, "-header")
        }, section.title) : null, section.subtitle ? /*#__PURE__*/_react.default.createElement(_ListSubheader.default, {
          isSideNav: "subheader",
          id: "".concat(id, "-subheader")
        }, section.subtitle) : null),
        listItems: section.items ? Object.keys(section.items).map(function (itemKey, index) {
          var item = section.items[itemKey];
          return {
            button: true,
            itemText: {
              primary: item.title
            },
            itemIcon: item.icon && /*#__PURE__*/_react.default.createElement("span", {
              className: (0, _classnames.default)(classes.icon, (0, _defineProperty2.default)({}, classes.iconIsActive, isSelected ? isSelected(item, itemKey, openSubNav, openSection, sectionKey) : _this2.isSelected(item, itemKey)))
            }, item.icon),
            onClick: item.subNavSections ? function () {
              toggleSubMenu(sectionKey, itemKey);
            } : item.onClick ? function () {
              toggleSubMenu();
              item.onClick(itemKey);
            } : null,
            href: item.href && !item.onClick && !item.subNavSections ? item.href : null,
            openInNewWindow: item.openInNewWindow,
            component: item.component,
            isSideNav: true,
            selected: isSelected ? isSelected(item, itemKey, openSubNav, openSection, sectionKey) : _this2.isSelected(item, itemKey),
            hide: item.hide
          };
        }) : []
      });
    }
  }]);
  return NavigationSection;
}(_react.Component);

exports.NavigationSection = NavigationSection;
(0, _defineProperty2.default)(NavigationSection, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * Provides the key of the open section
   */
  openSection: _propTypes.default.string.isRequired,

  /**
   * Provides the key of the open sub nav
   */
  openSubNav: _propTypes.default.string.isRequired,

  /**
   * The section to render
   */
  section: _shapes.NavigationSectionPropTypes.isRequired,

  /**
   * The unique key for the section from the parent object
   */
  sectionKey: _propTypes.default.string,

  /**
   * Function to toggle the sub menu
   */
  toggleSubMenu: _propTypes.default.func.isRequired,

  /**
   * Function to set selected attribute of the list item
   */
  isSelected: _propTypes.default.func,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired
});

var _default = (0, _styles.withStyles)(_styles2.styles)(NavigationSection);

exports.default = _default;